import React from 'react';


const ProjectExample = ({title, tagline, technologies, context, img, deployLink, ghLink, alt, summary}) => {
  return (
    <section className='project'>
      <div className='project-text'>
        <p className="project-header">{title}</p>
        <p className='project-tagline'>{tagline}</p>
        <ul>Technologies Used:</ul>
          {technologies.map(item => {return <li key={Date.now()}>{item}</li>})}
        <p className='date-created'>{summary}</p>
        <p className='date-created'>{context}</p>
      </div>
        <div className='project-preview'>
          <img alt={alt} className='project-img'src ={img} />
          <div className="overlay"></div>
          <a href={deployLink} target="_blank" rel="noreferrer"><div className="button"> Deployment Link </div></a>
          <a href={ghLink} target="_blank" rel="noreferrer"><div className="button button2"> View on GitHub</div></a>
        </div>
    </section>
  )
}

export default ProjectExample